import { render, staticRenderFns } from "./TireRemarks.vue?vue&type=template&id=82662b5c&"
import script from "./TireRemarks.vue?vue&type=script&lang=js&"
export * from "./TireRemarks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports